export default "__VITE_ASSET__CHSab5pz__"